/**
 * 備份佇列的項目。
 *
 * 狀態與失敗原因必須持久化：原因是使用者唯一能據以行動的資訊，放在記憶體或 toast 裡
 * 會在重新整理後消失，而整批備份本來就會跨越多次開關分頁。
 */
export type BackupQueueStatus = 'queued' | 'running' | 'done' | 'failed' | 'skipped'

export interface BackupQueueEntry {
  /** 本地作品識別碼，同時是主鍵。 */
  comicId: string
  status: BackupQueueStatus
  /** failed 或 skipped 的原因；其餘狀態為空字串。 */
  reason: string
  attempts: number
  queuedAt: number
  updatedAt: number
}

export function newQueueEntry(comicId: string, queuedAt: number): BackupQueueEntry {
  return { comicId, status: 'queued', reason: '', attempts: 0, queuedAt, updatedAt: queuedAt }
}

/** 尚未處理完的狀態。running 只在執行期間短暫存在，中斷後會被復原為 queued。 */
export function isPending(entry: Pick<BackupQueueEntry, 'status'>): boolean {
  return entry.status === 'queued' || entry.status === 'running'
}
